import { useRoute, useRouter } from '#imports';

export function getFirstRouteParam(param: string | string[]): string {
  if (!param) {
    return '';
  }

  if (Array.isArray(param)) {
    const [firstParam] = param;

    return String(firstParam);
  }

  return String(param);
}

export function normalizeRouteParams(params: string | string[]): string {
  const param = getFirstRouteParam(params);

  return String(param).toLowerCase();
}

export function clearQueryParams() {
  const route = useRoute();
  const router = useRouter();

  const { email, token, service, ref, home, ...query } = route.query;

  router.replace({ query });
}
